<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  * {
    font-family: OneNikeCurrency, "FuturaW01-ExtraBoldCond 774896",
    Futura-CondensedMedium, Roboto-Condensed-Light;
  }
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    width: 100vw;
    height:100vh;
    overflow-y: hidden;
  }

  /*html,body {height:100%;margin: 0}*/
</style>



// WEBPACK FOOTER //
// src/App.vue